import * as React from 'react';
import styled from 'styled-components';
import { rem } from 'polished';
import { FlexRowCenter } from './Flexbox/Flexbox';
import { Icon } from './Defaults';

const CheckIcon: any = styled(FlexRowCenter)`
  width: ${rem(11)};
  height: ${rem(16)};
  display: ${(props: any) => (props.selected ? 'flex' : 'none')};
  pointer-events: none;
`;

const StyledBox: any = styled(FlexRowCenter)`
  width: ${rem(24)};
  min-height: ${rem(24)};
  margin-right: ${rem(10)};
  border: ${rem(2)} solid ${props => props.theme.colors.btnPrimary};
  border-radius: ${rem(4)};
  background: ${(props: any) =>
    props.selected ? props.theme.colors.btnPrimary : 'transparent'};
  transition: all 0.2s ease;
  flex-shrink: 0;

  &:hover {
    cursor: pointer;
    opacity: 0.8;
  }
`;

interface CheckBoxProps {
  id?: string;
  onClick?: (e: any) => void;
  selected: boolean;
}

export class CheckBox extends React.Component<CheckBoxProps> {
  shouldComponentUpdate(nextProps) {
    return this.props.selected !== nextProps.selected;
  }

  clickHandler = e => {
    if (this.props.onClick) {
      this.props.onClick(e);
    }
  };
  render() {
    const { id, selected } = this.props;
    return (
      <StyledBox id={id} onClick={this.clickHandler} selected={selected}>
        <CheckIcon selected={selected}>
          <Icon src={'/images/done-1.svg'} />
        </CheckIcon>
      </StyledBox>
    );
  }
}
